import { inject, Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private readonly spinnerService = inject(NgxSpinnerService);

  private spinnerCount = 0;

  startSpinner(spinnerName: string = 'default') {
    this.spinnerService.show(spinnerName);
    this.spinnerCount++;
  }

  stopSpinner(spinnerName: string = 'default') {
    this.spinnerCount--;
    this.spinnerService.hide(spinnerName)
  }

  isSpinnerVisible(): boolean {
    return this.spinnerCount > 0;
  }

  getSpinner(name: string) {
    return this.spinnerService.getSpinner(name);
  }
}
